import { render } from "./LoginNew.vue?vue&type=template&id=2a848134&scoped=true"
import script from "./LoginNew.vue?vue&type=script&lang=js"
export * from "./LoginNew.vue?vue&type=script&lang=js"

import "./LoginNew.vue?vue&type=style&index=0&id=2a848134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a848134"]])

export default __exports__